import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import Flex from "../../../components/flex"

const AptHeaderContent = ({ children, label = "운영 세대 현황" }) => {
  const { apt_name } = aptSearchStore((s) => s.pickApt)

  return (
    <Flex className="items-center w-full" gap={4}>
      <div className="mr-auto">{children}</div>

      <article className="flex items-center gap-3 mr-2">
        <div className="flex flex-col">
          <span className="text-[11px] font-medium tracking-wide text-gray-400 uppercase text-right">
            {label}
          </span>

          <span className="font-bold text-gray-700">{apt_name}</span>
        </div>
      </article>

      <article
        className="w-9 h-9 rounded-xl mr-2
          bg-linear-to-br from-blue-50 to-sky-100
          flex items-center justify-center shrink-0
        "
      >
        <img
          src="/images/apt-overview-building.png"
          alt="building"
          className="w-7 h-7 object-contain"
        />
      </article>
    </Flex>
  )
}

export default AptHeaderContent
